module.exports = __webpack_public_path__ + "img/card.705e6f94.png";